import request from '@/utils/request'
// 查询问卷模板
export function getTemplate(visitNo,patientId) {
  return request({
    url: `/feature/questionnaire/getTemplate?visitNo=${visitNo}&patientId=${patientId}`,
    method: 'get',
  })
}
// 保存问卷接口
export function saveAnswer(data) {
  return request({
    url: `/feature/questionnaire/saveAnswer`,
    method: 'post',
    data
  })
}